module.exports = __webpack_public_path__ + "static/background-test-yourself-c4f0044a6f55ee9579e741fc36b923ba.jpg";